































































































































































































































































































import { Component } from 'vue-mixin-decorator';
import { loadStripe } from '@stripe/stripe-js';

import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';
import SerialCodeCheckbox from '@/components/SerialCodeCheckbox.vue';

import { REGISTER_USER_INFO, EXAMINEE_ITEMS } from '@/classification/SessionStorageKey';

import * as JwtUtil from '@/common/JwtUtil';
import * as StringUtil from '@/common/StringUtil';

import RepositoryFactory from '@/repository/RepositoryFactory';

import ExamInfo from '@/models/exam/ExamInfo';
import RegisterUserInfo from '@/models/account/RegisterUserInfo';
import ExamineeAttribute from '@/models/account/ExamineeAttribute';
import GoodsDetail from '@/models/goods/GoodsDetail';
import RankGetCondition from '@/models/rank/apiParam/RankGetCondition';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'e-indicator': IndicatorModal,
      SerialCodeCheckbox,
    },
  },
)
export default class RegistConfirm extends BaseView {
  private isUseSerialCode = true;

  private examInfo = new ExamInfo();

  private jwt = null;

  private registerUserInfo = new RegisterUserInfo();

  private examineeItems: any[] = [];

  private isOnlyRegister = true;

  private AccountRepository = RepositoryFactory.get().account;

  private EntryRepository = RepositoryFactory.get().entry;

  private RankRepository = RepositoryFactory.get().rank;

  private GoodsRepository = RepositoryFactory.get().goods;

  private isIndicatorDisplay = false;

  private queryRankCode = '';

  private isEntryBadCondition = false;

  private msgEntryBadCondition = '';

  private isInvalidToken = false;

  private goodsCode = '';

  private isGoodsConfirm = false;

  private goodsInfo = new GoodsDetail();

  private serialCode = '';

  get showCreditPaymentBtn() {
    if (this.isGoodsConfirm && this.goodsInfo.canEntry) {
      return true;
    }
    if (this.jwt !== null && this.examInfo.paymentType === 'pay') {
      return true;
    }
    if (this.jwt === null && this.examInfo.paymentType === 'pay' && !this.isOnlyRegister) {
      return true;
    }
    if (this.isGoodsConfirm) {
      return true;
    }
    return false;
  }

  private async created() {
    this.isIndicatorDisplay = true;
    this.jwt = JwtUtil.getJwtInfo();

    /* eslint-disable @typescript-eslint/camelcase */
    const { rank, goods_code } = this.$route.query;
    if (goods_code !== undefined) {
      // グッズ購入用処理
      this.goodsCode = String(goods_code);
      this.isGoodsConfirm = true;
      this.isOnlyRegister = false;
      await this.getExamInfo();
      await this.getGoodsInfo();
    } else {
      // 新規登録・試験申し込み処理
      if (this.jwt === null) {
        this.restorationUserInfoFromSessionStorage();
      } else {
        this.registerUserInfo.examRankCode = String(rank);
        this.isOnlyRegister = false;
      }

      await this.getExamInfo();
      await this.getExamRankInfo();
    }

    this.isIndicatorDisplay = false;
  }

  private mounted() {
    this.initialStaticScript();
  }

  /**
   * 検定情報を取得する
   */
  private async getExamInfo() {
    try {
      const ExamRepository = RepositoryFactory.get().exam;
      await ExamRepository.getExam().then((response) => {
        this.examInfo.examTitle = response.data.exam_title;
        this.examInfo.useNameFlg = response.data.use_name_flg;
        this.examInfo.useNameKanaFlg = response.data.use_name_kana_flg;
        this.examInfo.useGenderFlg = response.data.use_gender_flg;
        this.examInfo.useAddressFlg = response.data.use_address_flg;
        this.examInfo.useMailAnnounceFlg = response.data.use_mail_announce_flg;
        this.examInfo.usePaymentsKonbiniFlg = response.data.use_payments_konbni_flg;
        this.examInfo.usePaymentsSerialFlg = response.data.use_payments_serial_flg;
        this.examInfo.konbiniExpireDays = response.data.konbini_expire_days;
      }).catch(() => {
        this.redirectToTOP();
      });
    } catch (e) {
      this.redirectToTOP();
    }
  }

  /**
   * 検定ランク情報を取得する
   */
  private async getExamRankInfo() {
    try {
      const rankCode: string = StringUtil.isEmpty(this.registerUserInfo.examRankCode)
        ? '' : String(this.registerUserInfo.examRankCode);
      if (StringUtil.isEmpty(rankCode)) return;
      const rankGetCondition = new RankGetCondition();
      rankGetCondition.needFee = true;

      await this.RankRepository.getRankInfo(rankCode, rankGetCondition).then((response) => {
        if (response.status === 200) {
          const format = 'MM/DD/YYYY hh:mm A';
          this.examInfo.rankTitle = response.data.exam_rank_title;
          this.examInfo.periodStart = StringUtil.toJapanDateString(response.data.examination_period_start, format);
          this.examInfo.periodEnd = StringUtil.toJapanDateString(response.data.examination_period_end, format);
          this.examInfo.paymentType = response.data.exam_fee_type;
          if (response.data.fees.length > 0) {
            this.examInfo.fee = StringUtil.separateNumber(response.data.fees[0].fee);
          } else {
            this.examInfo.fee = '0';
          }
        }
      }).catch(() => {
        this.redirectToTOP();
      });
    } catch (e) {
      this.redirectToTOP();
    }
  }

  /**
   * グッズ情報を取得する
   */
  private async getGoodsInfo() {
    try {
      const rankGetCondition = new RankGetCondition();
      rankGetCondition.needFee = true;

      await this.GoodsRepository.getGoods(this.goodsCode, rankGetCondition).then((response) => {
        if (response.status === 200) {
          const format = 'YYYY年MM月DD日（dd） HH:mm:ss';
          this.goodsInfo.goodsTitle = response.data.goods_title;
          this.goodsInfo.canEntry = response.data.can_entry;
          this.goodsInfo.periodStart = StringUtil.toJapanDateString(response.data.request_period_start, format);
          this.goodsInfo.periodEnd = StringUtil.toJapanDateString(response.data.request_period_end, format);
          if (response.data.fees.length > 0) {
            this.goodsInfo.fee = StringUtil.separateNumber(response.data.fees[0].fee);
          } else {
            this.goodsInfo.fee = '0';
          }
          if (!this.goodsInfo.canEntry) {
            this.$router.replace({ path: this.paths.PURCHASE_CANNOT_PURCHASE });
          }
        }
      }).catch(() => {
        this.redirectToTOP();
      });
    } catch (e) {
      this.redirectToTOP();
    }
  }

  /**
   *  受験者情報の本登録と申し込みを行います。
   */
  private async registerAndEntry() {
    this.isIndicatorDisplay = true;
    this.isEntryBadCondition = false;
    this.msgEntryBadCondition = '';

    // SessionStorageの登録情報を削除
    sessionStorage.removeItem(REGISTER_USER_INFO);
    sessionStorage.removeItem(EXAMINEE_ITEMS);

    if (this.jwt === null) {
      // ログインしていない場合、登録
      const userInfo = this.registerUserInfo;
      try {
        const examineeAttributes: ExamineeAttribute[] = [];
        Object.keys(this.examineeItems).forEach((key: any) => {
          const item = this.examineeItems[key];
          const attribute = new ExamineeAttribute();
          attribute.optionItemCode = item.optionItemCode;
          if (item.inputType === 'checkbox') {
            attribute.inputText = item.values.length === 0 ? '' : item.values.join(',');
          } else if (item.inputType === 'combo') {
            attribute.inputText = '';
            item.choices.forEach((choice: any) => {
              if (choice.displayName === item.value.trim()) {
                attribute.inputText = choice.value;
              }
            });
          } else {
            attribute.inputText = StringUtil.isEmpty(item.value) ? '' : item.value;
          }
          examineeAttributes.push(this.AccountRepository.convert.serialize(attribute));
        });
        userInfo.examineeAttributes = examineeAttributes;

        // 受験者情報の本登録
        await this.AccountRepository.regist(userInfo).then((response) => {
          // レスポンスのJWTを使用してログイン状態にする
          JwtUtil.setJwt(response.data.access_token);

          if (this.isOnlyRegister) {
            this.$router.replace(this.paths.ACCOUNT_COMPLETE);
          }
        }).catch(() => {
          this.isInvalidToken = true;
        });
      } catch (_) {
        JwtUtil.deleteJwt();
      } finally {
        if (this.isOnlyRegister) {
          this.isIndicatorDisplay = false;
        }
      }
    }

    if (!this.isOnlyRegister) {
      try {
        let rankCode = '';
        if (this.isGoodsConfirm && !this.goodsInfo.canEntry) {
          this.$router.replace({ path: this.paths.PURCHASE_CANNOT_PURCHASE });
        } else if (this.isGoodsConfirm) {
          rankCode = StringUtil.decodeFromBase64Url(this.goodsCode);
        } else {
          rankCode = StringUtil.decodeFromBase64Url(String(this.registerUserInfo.examRankCode));
        }
        let sessionId = null;
        let entryCode = '';
        // シリアルコード使用しない場合、APIにデータを送るため全角スペースを入れる。
        this.serialCode = StringUtil.isEmpty(this.serialCode) ? '　' : this.serialCode;
        await this.EntryRepository.entry(rankCode, this.serialCode).then((response: any) => {
          sessionId = response.data.stripe_session_id;
          entryCode = response.data.examination_entry_code;
        }).catch((err) => {
          if (err.response.status === 400) {
            this.isEntryBadCondition = true;
            this.msgEntryBadCondition = String(err.response.data.error).replace(/\r?\n/g, '<br/>');
          } else {
            this.isEntryBadCondition = true;
            this.msgEntryBadCondition = '申し込みに失敗しました。';
          }
        });

        if (this.isEntryBadCondition) return;

        if (sessionId === null) {
          // eslint-disable-next-line @typescript-eslint/camelcase
          this.$router.replace({ path: this.paths.EXAM_READY, query: { rank: this.registerUserInfo.examRankCode, examination_entry_code: entryCode, is_callback: '0' } });
        } else {
          // セッションIDを使ってCheckout（Stripeの支払い画面）にリダイレクト
          const stripe = await loadStripe(String(process.env.VUE_APP_STRIPE_SITE_KEY));
          if (stripe !== null) {
            stripe.redirectToCheckout({ sessionId });
          }
        }
      } catch (_) {
        JwtUtil.deleteJwt();
      } finally {
        this.isIndicatorDisplay = false;
      }
    }
  }

  /**
   * CSSとJSの読み込み
   */
  private initialStaticScript() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const AccountCommonCss = document.createElement('link');
    AccountCommonCss.rel = 'stylesheet';
    AccountCommonCss.href = '/account/css/common.css';
    this.$el.appendChild(AccountCommonCss);

    const ConfirmCss = document.createElement('link');
    ConfirmCss.rel = 'stylesheet';
    ConfirmCss.href = '/account/css/confirm.css';
    this.$el.appendChild(ConfirmCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  /**
   * SessionStorageから入力情報の復元をする
   */
  private restorationUserInfoFromSessionStorage() {
    const storageRegisterUserInfo = sessionStorage.getItem(REGISTER_USER_INFO);
    if (storageRegisterUserInfo !== null) {
      const userInfo = this.registerUserInfo;
      const info = JSON.parse(storageRegisterUserInfo);
      userInfo.userId = info.userId;
      userInfo.password = info.password;
      userInfo.passwordConfirm = info.passwordConfirm;
      userInfo.firstName = StringUtil.isEmpty(info.firstName) ? null : info.firstName;
      userInfo.lastName = StringUtil.isEmpty(info.lastName) ? null : info.lastName;
      userInfo.firstNameKana = StringUtil.isEmpty(info.firstNameKana) ? null : info.firstNameKana;
      userInfo.lastNameKana = StringUtil.isEmpty(info.lastNameKana) ? null : info.lastNameKana;
      userInfo.gender = StringUtil.isEmpty(info.gender) ? null : info.gender;
      userInfo.birthYear = info.birthYear;
      userInfo.birthMonth = info.birthMonth;
      userInfo.birthDate = info.birthDate;
      userInfo.postalCode = StringUtil.isEmpty(info.postalCode) ? null : info.postalCode;
      userInfo.prefecture = StringUtil.isEmpty(info.prefecture) ? null : info.prefecture;
      userInfo.city = StringUtil.isEmpty(info.city) ? null : info.city;
      userInfo.street = StringUtil.isEmpty(info.street) ? null : info.street;
      userInfo.buildingName = StringUtil.isEmpty(info.buildingName) ? null : info.buildingName;
      userInfo.phoneNumber01 = StringUtil.isEmpty(info.phoneNumber01) ? null : info.phoneNumber01;
      userInfo.phoneNumber02 = StringUtil.isEmpty(info.phoneNumber02) ? null : info.phoneNumber02;
      userInfo.phoneNumber03 = StringUtil.isEmpty(info.phoneNumber03) ? null : info.phoneNumber03;
      userInfo.mailAddress = info.mailAddress;
      userInfo.token = info.token;
      userInfo.isReceiveMailAnnounce = StringUtil.isEmpty(info.isReceiveMailAnnounce) ? false : info.isReceiveMailAnnounce;
      userInfo.examRankCode = info.examRankCode;
      this.isOnlyRegister = StringUtil.isEmpty(userInfo.examRankCode);
    }
    const storageExamineeItems = sessionStorage.getItem(EXAMINEE_ITEMS);
    if (storageExamineeItems !== null) {
      this.examineeItems = JSON.parse(storageExamineeItems);
    }
  }

  /**
   * 変更ボタン押下時の処理
   * トークンとBase64エンコードされたランクコードを付与したURLで入力画面に遷移します。
   */
  private changeRegisterInfo() {
    const { examRankCode, token } = this.registerUserInfo;
    if (StringUtil.isEmpty(examRankCode)) {
      this.$router.replace(`${this.paths.ENTRY}?token=${token}`);
    } else {
      this.$router.replace(`${this.paths.ENTRY}?token=${token}&rank=${examRankCode}`);
    }
  }

  /**
   * TOP画面に遷移
   */
  private redirectToTOP() {
    this.$router.replace(this.paths.TOP);
  }

  /**
   * シリアルコード使用のチェック切り替え
   */
  private changeCheckBox() {
    this.isUseSerialCode = !this.isUseSerialCode;
    // シリアルコード使用のチェックを外した場合、シリアルコード入力欄・エラー表示をリセット
    if (this.isUseSerialCode === false) {
      this.serialCode = '';
      this.isEntryBadCondition = false;
      this.msgEntryBadCondition = '';
    }
  }
}
